import React from 'react';
import { Link } from 'react-router-dom';
import { subscriptionDisplay } from '../../../utils/subscriptionDisplay';
import { formatUiDate } from '../../../utils/uiTranslation';
import TrialStartButton from '../../Trial/TrialStartButton';

const BillingSection = ({
  accessType,
  handleManageSubscription,
  language,
  onShowSubscriptionPopup,
  subscriptionData,
  t,
  trial
}) => {
  const subscriptionCopy = subscriptionDisplay(subscriptionData, language);

  return (
    <div className="profile-section-stack">
      <div className="settings-section-heading">
        <div>
          <h2>{t('billing.title')}</h2>
          <p>{t('billing.description')}</p>
        </div>
      </div>
      {subscriptionData.canManage && (
        <section className="profile-panel">
          <div className="profile-panel-header">
            <div>
              <h2>{t('billing.workspacePlan')}</h2>
            </div>
          </div>

          <div className="profile-note-stack">
            <div className="profile-keyline">
              <strong>{subscriptionCopy.plan}</strong>
              <span>{subscriptionCopy.billingDate}</span>
              <span>{subscriptionCopy.status}</span>
            </div>
            <button type="button" className="profile-btn-primary" onClick={handleManageSubscription}>
              {t('subscription.manage', 'Manage Subscription')}
            </button>
          </div>
        </section>
      )}

      {accessType === 'trial' && trial && (
        <section className="profile-panel">
          <div className="profile-panel-header">
            <div>
              <h2>{t('account.upgradeWindow', 'Upgrade window')}</h2>
            </div>
          </div>

          <div className="profile-note-stack">
            <div className="profile-keyline">
              <strong>{t('subscription.trialActive', 'Free trial active')}</strong>
              <span>
                {trial.daysRemaining} {t('subscription.daysRemaining', 'days remaining')}
              </span>
              <span>
                {t('subscription.trialEnds', 'Trial ends')}: {formatUiDate(trial.expiresAt, { dateStyle: 'long' }, language)}
              </span>
            </div>
            <button type="button" className="profile-btn-primary" onClick={onShowSubscriptionPopup}>
              {t('subscription.upgradeToPremium', 'Upgrade to Premium')}
            </button>
          </div>
        </section>
      )}

      {accessType === 'none' && !subscriptionData.canManage && (
        <section className="profile-panel">
          <div className="profile-panel-header">
            <div>
              <h2>{t('account.noActivePlan', 'No active plan')}</h2>
            </div>
          </div>
          <div className="profile-note-stack">
            <p className="profile-muted-copy">
              {t('subscription.noSubscription', "You don't have an active subscription or trial.")}
            </p>
            <TrialStartButton productType="ats" />
          </div>
        </section>
      )}

      {accessType === 'trial_expired' && !subscriptionData.canManage && (
        <section className="profile-panel">
          <div className="profile-panel-header">
            <div>
              <h2>{t('billing.trialExpired')}</h2>
              <p>{t('billing.trialExpiredDescription')}</p>
            </div>
          </div>
          <div className="profile-panel-actions profile-panel-actions--left">
            <button type="button" className="profile-btn-primary" onClick={onShowSubscriptionPopup}>
              {t('subscription.upgradeToPremium')}
            </button>
          </div>
        </section>
      )}
      <div className="settings-notice">
        <i className="fa-solid fa-plug" aria-hidden="true" />
        <div>
          <strong>{t('billing.connectorTitle')}</strong>
          <p>{t('billing.connectorDescription')}</p>
        </div>
        <Link to="/profile?tab=usage" className="profile-btn-secondary">{t('billing.viewConnectorUsage')}</Link>
      </div>
    </div>
  );
};

export default BillingSection;
